const initWhatsAppChat = () => {
	const widget = document.querySelector("[data-whatsapp-chat]");
	if (!widget) return;

	const panel = widget.querySelector("[data-whatsapp-panel]");
	const button = widget.querySelector("[data-whatsapp-button]");
	const close = widget.querySelector("[data-whatsapp-close]");
	if (!panel || !button || !close) return;

	const isMobile = () => window.matchMedia("(max-width: 767px)").matches;

	const setPanelState = (isOpen) => {
		panel.hidden = !isOpen;
		widget.classList.toggle("cyprus-whatsapp--open", isOpen);
		button.setAttribute("aria-expanded", String(isOpen));
	};

	button.setAttribute("aria-expanded", "false");
	button.addEventListener("click", (event) => {
		// On mobile, keep button compact and navigate directly to WhatsApp
		if (isMobile()) {
			return;
		}

		if (!panel.hidden) return;
		event.preventDefault();
		setPanelState(true);
	});

	close.addEventListener("click", () => setPanelState(false));

	document.addEventListener("click", (event) => {
		if (!widget.contains(event.target)) setPanelState(false);
	});

	// Strictly prohibit auto-opening popup on mobile
	window.setTimeout(() => {
		if (isMobile()) return;
		if (window.sessionStorage.getItem("cyprusWhatsappSeen")) return;
		setPanelState(true);
		window.sessionStorage.setItem("cyprusWhatsappSeen", "1");
	}, 4000);

	// Hide widget while cookie banner is active to prevent any overlap
	const syncCookieBannerVisibility = () => {
		const cookiesPopup = document.querySelector(".wd-cookies-popup");
		if (!cookiesPopup) return;
		const isVisible =
			cookiesPopup.classList.contains("popup-display") &&
			!cookiesPopup.classList.contains("popup-hide");
		widget.classList.toggle("cyprus-whatsapp--hidden-cookies", isVisible);
	};

	syncCookieBannerVisibility();
	const cookiesEl = document.querySelector(".wd-cookies-popup");
	if (cookiesEl && typeof MutationObserver !== "undefined") {
		const observer = new MutationObserver(syncCookieBannerVisibility);
		observer.observe(cookiesEl, { attributes: true, attributeFilter: ["class", "style"] });
	}
};

document.addEventListener("DOMContentLoaded", initWhatsAppChat);
